import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import Input from 'components/input/input/input';
import { useField, useFormikContext } from 'formik';
import { createPopper } from '@popperjs/core';
import { ErrorMsg } from './components/error-msg';
import { Root, Label } from './input.styles';
import { TFormikInput } from '../types';

const AppFormikInput: React.FC<TFormikInput> = ({
    id,
    name,
    label,
    labelPos,
    errorPos,
    component: InputComponent = Input,
    ...rest
}) => {
    const form = useFormikContext();
    const [field, meta] = useField(name);
    const refInput = useRef<HTMLDivElement>(null);
    const refError = useRef<HTMLDivElement>(null);
    const [isError, setIsError] = useState<boolean>(false);

    const inputProps = {
        ...rest.inputProps,
        placeholder: rest?.placeholder,
    };

    useLayoutEffect(() => {
        if (
            refError?.current &&
            refInput?.current &&
            meta.touched &&
            meta.error
        ) {
            createPopper(refInput.current, refError.current, {
                placement: errorPos ?? 'right',
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, 5],
                        },
                    },
                ],
            });
        }
    });

    useEffect(() => {
        if (meta.touched && meta.error) {
            setIsError(true);
        } else {
            setIsError(false);
        }
    }, [meta.error, meta.touched]);

    return (
        <Root labelPos={labelPos}>
            {label ? <Label date-id={'label'}>{label}</Label> : null}
            <InputComponent
                id={id}
                date-id={'form-input'}
                myRef={refInput}
                {...rest}
                {...field}
                inputProps={inputProps}
                isLoading={form.isValidating}
                isError={isError}
            />
            {meta.touched && meta.error ? (
                <ErrorMsg myRef={refError}>{meta.error}</ErrorMsg>
            ) : null}
        </Root>
    );
};

export default AppFormikInput;
